export default "__VITE_ASSET__BKsY$XWw__"